// SAPM/PVsyst presets match pvlib.temperature.TEMPERATURE_MODEL_PARAMETERS.
// PVGIS Faiman pairs are for crystalline silicon (JRC methods, section 5.2.4).
// Absence of a model entry means legacy saved settings, never a migration.
export const THERMAL_PRESETS = {
  sapm: {
    open_rack_glass_polymer: { a: -3.56, b: -0.075, deltaT: 3 },
    open_rack_glass_glass: { a: -3.47, b: -0.0594, deltaT: 3 },
    close_mount_glass_glass: { a: -2.98, b: -0.0471, deltaT: 1 },
    insulated_back_glass_polymer: { a: -2.81, b: -0.0455, deltaT: 0 },
  },
  pvsyst: {
    freestanding: { u_c: 29, u_v: 0 },
    semi_integrated: { u_c: 20, u_v: 0 },
    insulated: { u_c: 15, u_v: 0 },
  },
  faiman: {
    reference: { u0: 25, u1: 6.84 },
    pvgis_csi_freestanding: { u0: 26.9, u1: 6.2 },
    pvgis_csi_roof: { u0: 20, u1: 3.2 },
  },
};
export const THERMAL_INSTALLATION = {
  ground: { sapm: 'open_rack_glass_polymer', pvsyst: 'freestanding' },
  roof_frame: { sapm: 'close_mount_glass_glass', pvsyst: 'semi_integrated' },
  roof_flush: { sapm: 'insulated_back_glass_polymer', pvsyst: 'insulated' },
};
export const THERMAL_UNITS = {
  a: '', b: 's/m', deltaT: '°C', u_c: 'W/(m²·K)', u_v: 'W·s/(m³·K)',
  u0: 'W/(m²·K)', u1: 'W·s/(m³·K)',
};
export function resolveThermalSettings(model = 'sapm', settings, mounting, installation = 'ground') {
  const type = THERMAL_INSTALLATION[installation] || THERMAL_INSTALLATION.ground;
  const presets = THERMAL_PRESETS[model] || THERMAL_PRESETS.sapm;
  const entry = settings?.[model];
  const mode = entry?.mode || 'legacy';
  let preset = model === 'faiman' ? 'reference' : type[model];
  if (mode === 'legacy' && model === 'sapm') {
    preset = mounting ? (presets[mounting] ? mounting : 'open_rack_glass_polymer') : type.sapm;
  }
  if (mode === 'preset') preset = entry.preset;
  const parameters = mode === 'custom' ? entry.parameters : presets[preset];
  const knownMode = ['legacy', 'auto', 'preset', 'custom'].includes(mode);
  return { mode, preset, parameters: parameters || {}, valid: knownMode && validThermalParameters(model, parameters) };
}
export function validThermalParameters(model, parameters) {
  const keys = Object.keys(Object.values(THERMAL_PRESETS[model] || {})[0] || {});
  return keys.length > 0 && keys.every((key) => {
    const raw = parameters?.[key];
    if (raw == null || typeof raw === 'boolean' || String(raw).trim() === '') return false;
    const value = Number(raw);
    if (!Number.isFinite(value)) return false;
    if (key === 'a') return value < 0;
    if (key === 'b') return value <= 0;
    return ['u_c', 'u0'].includes(key) ? value > 0 : value >= 0;
  });
}
